module.exports = __webpack_public_path__ + "img/1533097439.f994a38d.jpg";